import { render, staticRenderFns } from "./ItemProductAli.vue?vue&type=template&id=81798c5a&"
import script from "./ItemProductAli.vue?vue&type=script&lang=js&"
export * from "./ItemProductAli.vue?vue&type=script&lang=js&"
import style0 from "./ItemProductAli.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports